export default "__VITE_ASSET__BpdLIrON__"